import { Component, OnInit } from '@angular/core';
import { ComponentBase } from '../../../../../base-classes/componet-base';
import { DatePipe } from '@angular/common';
import { RoutingService } from '../../../../../services/routing-service/routing.service';
import { InterCopmonentDataCarrierService } from '../../../../../services/inter-copmonent-data-carrier-service/inter-copmonent-data-carrier.service';
import { CalendarDataCarrierService } from '../../services/calendar-datacarrier-service/calendar-data-carrier.service';
import { DatewiseEvents } from '../../models/datewise-events';
import { WidgetType } from '../../models/calendar-view-cache';
import { PrifactRoute } from '../../../../../models/prifact-route';
import { DateUtils } from '../../../../../utils/date-utils';
import { MobileCalendarModel } from '../../models/mobile-calendar-model';
import { MobileEventsService } from '../../services/mobile-events-servics/mobile-events.service';
import { AcademicYearService } from '../../../../../services/user/academic-year/academic-year.service';

@Component({
  selector: 'app-mobile-month',
  templateUrl: './mobile-month.component.html',
  styleUrls: ['./mobile-month.component.scss']
})
export class MobileMonthComponent extends ComponentBase implements OnInit {

  constructor(private datePipe: DatePipe
    , private routingService: RoutingService
    , private interComponentService: InterCopmonentDataCarrierService
    , private calendarDataCarrierSvc: CalendarDataCarrierService
    , private mobileEventsService: MobileEventsService
    , private academicYearService: AcademicYearService
  ) {
    super();
  }

  dayNames = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
  currentMonth: string;
  academic_year: Array<MobileCalendarModel> = [];
  activeSlide: number;
  todays_date: Date = new Date();
  selected_month: MobileCalendarModel;
  todaysdate = DateUtils.DateToISOString(new Date()).split('T')[0];

  ngOnInit() {
    let sub1 = this.academicYearService.getAcademicYear()
      .subscribe(res => {
        let start_date: Date = DateUtils.parseDateAndTime(res.start_date);
        let end_date: Date = DateUtils.parseDateAndTime(res.end_date);
        while (start_date < end_date) {
          let month: MobileCalendarModel = new MobileCalendarModel();
          month.month = start_date.getMonth();
          month.year = start_date.getFullYear();
          month.weeks = [];
          let month_view_start_date = DateUtils.getStartDateForMonthView(start_date);
          let month_view_end_date = new Date(month_view_start_date);
          month_view_end_date.setDate(month_view_end_date.getDate() + 42);
          let days_in_month: Array<DatewiseEvents> = [];
          while (month_view_start_date < month_view_end_date) {
            let day = new DatewiseEvents();
            day.event_date = DateUtils.DateToISOString(month_view_start_date);
            days_in_month.push(day);
            month_view_start_date.setDate(month_view_start_date.getDate() + 1);
          }
          while (days_in_month.length > 0) {
            month.weeks.push(days_in_month.splice(0, 7));
          }
          this.academic_year.push(month);
          start_date.setMonth(start_date.getMonth() + 1);
        }
        this.activeSlide = this.academic_year.findIndex(o => o.month == this.todays_date.getMonth() && o.year == this.todays_date.getFullYear());
        if (this.activeSlide < 0) {
          this.activeSlide = this.academic_year.length - 1;
        }
        this.onSwipe(this.activeSlide);
      });
    this.addSubscription(sub1);


    let sub2 = this.mobileEventsService.months$.subscribe(curr_month => {
      this.selected_month.weeks.forEach((week, i) => {
        week.forEach((day, j) => {
          let d = curr_month.event_days.find(o => o.event_date.split('T')[0] == day.event_date.split('T')[0]);
          if (d) {
            this.selected_month.weeks[i][j] = d;
          }
        });
      });
    });
    this.addSubscription(sub2);

    let sub3 = this.calendarDataCarrierSvc.todayClicked$.subscribe(res => {
      this.activeSlide = this.academic_year.findIndex(o => o.month == this.todays_date.getMonth() && o.year == this.todays_date.getFullYear());
      if (!this.activeSlide) {
        this.activeSlide = this.academic_year.length - 1;
      }
      this.onSwipe(this.activeSlide);
    });
    this.addSubscription(sub3);
  }

  homeworkClicked(day: DatewiseEvents) {
    this.interComponentService.save("hwDate", day.event_date);
    let route = new PrifactRoute();
    route.url = '/pages/homeworks';
    route.append_current_url_to_history = true;
    this.routingService.navigate(route);
  }

  isSameMonth(day: DatewiseEvents) {
    let month = this.datePipe.transform(day.event_date.split('T')[0], "MMMM yyyy");
    if (month != this.currentMonth) {
      return true;
    }
  }

  onSwipe(index: number) {
    this.activeSlide = index;
    this.selected_month = this.academic_year[index];
    this.currentMonth = this.datePipe.transform(this.selected_month.first_day_of_month, "MMMM yyyy");
    this.calendarDataCarrierSvc.changeView(WidgetType.month, this.currentMonth);
    this.mobileEventsService.getEventsForMonth(this.selected_month.first_day_of_month);
  }
}
